/**
 * This module exports a single model instance that can be
 * imported and referenced from anywhere in the code base
 */
import { Model } from 'backbone';

export const ATTRIBUTES = Object.freeze({
	arcadeName: 'arcadeName',
	arcadeTitle: 'arcadeTitle',
	registrationRequired: 'registrationRequired',
});

export default new Model();
